// src/api/hireAgreements.js
import { requestJson } from './http';

// List all hire agreements
export function fetchHireAgreements() {
  return requestJson('/hire-agreements');
}

// Get a single hire agreement
export function fetchHireAgreement(id) {
  return requestJson(`/hire-agreements/${id}`);
}

// Create a new hire agreement
export function createHireAgreement(data) {
  return requestJson('/hire-agreements', {
    method: 'POST',
    body: data,
  });
}

// Update an existing hire agreement
export function updateHireAgreement(id, updates) {
  return requestJson(`/hire-agreements/${id}`, {
    method: 'PUT',
    body: updates,
  });
}

// Delete a hire agreement
export async function deleteHireAgreement(id) {
  await requestJson(`/hire-agreements/${id}`, {
    method: 'DELETE',
    expectJson: false,
  });
}
